/* Sahiya - renonciation au droit de retractation.
   Verrouille les boutons d'achat tant que la case n'est pas cochee, horodate la
   propriete de ligne, et bloque le bouton Commander quand la propriete manque.
   Aucune librairie externe. */

(function () {
  'use strict';

  if (window.__sahiyaRenonciation) return;
  window.__sahiyaRenonciation = true;

  var PROPRIETE = 'Renonciation au droit de rétractation';

  function deuxChiffres(n) {
    return n < 10 ? '0' + n : '' + n;
  }

  function horodatage() {
    var d = new Date();
    var decalage = -d.getTimezoneOffset();
    var signe = decalage < 0 ? '-' : '+';
    var absolu = Math.abs(decalage);
    var heures = deuxChiffres(Math.floor(absolu / 60));
    var minutes = absolu % 60;
    var fuseau = 'UTC' + signe + heures + (minutes ? ':' + deuxChiffres(minutes) : '');
    return 'Oui — ' + deuxChiffres(d.getDate()) + '/' + deuxChiffres(d.getMonth() + 1) + '/' +
      d.getFullYear() + ' ' + deuxChiffres(d.getHours()) + ':' + deuxChiffres(d.getMinutes()) +
      ' (' + fuseau + ')';
  }

  function signaler(bloc) {
    if (!bloc) return;
    var cadre = bloc.getBoundingClientRect();
    if (cadre.top < 0 || cadre.bottom > window.innerHeight) {
      bloc.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    bloc.classList.remove('sahiya-renonc--alerte');
    void bloc.offsetWidth;
    bloc.classList.add('sahiya-renonc--alerte');
    window.setTimeout(function () {
      bloc.classList.remove('sahiya-renonc--alerte');
    }, 2400);
  }

  function poserEcran(hote, auClic) {
    if (!hote) return;
    hote.classList.add('sahiya-renonc__hote');
    var enfants = hote.children;
    for (var i = 0; i < enfants.length; i++) {
      if (enfants[i].classList.contains('sahiya-renonc__ecran')) return;
    }
    var ecran = document.createElement('div');
    /* ignore-empty : base.css du thème masque tous les éléments vides
       (div:empty:not(.ignore-empty) { display: none }). Sans cette classe,
       l'écran fait 0x0 et le bouton de paiement accéléré reste cliquable. */
    ecran.className = 'sahiya-renonc__ecran ignore-empty';
    ecran.setAttribute('aria-hidden', 'true');
    ecran.addEventListener('click', function (evenement) {
      evenement.preventDefault();
      evenement.stopPropagation();
      auClic();
    });
    hote.appendChild(ecran);
  }

  /* ------------------------------------------------------------------ */
  /* Fiche produit, quick view, produit en vedette                      */
  /* ------------------------------------------------------------------ */

  function initFiche(bloc) {
    if (bloc.dataset.sahiyaPret === '1') return;

    var formulaire = bloc.closest('form');
    var boutons = formulaire && formulaire.querySelector('.product-form__buttons');
    if (!formulaire || !boutons) return;

    var caseACocher = bloc.querySelector('.sahiya-renonc__case');
    var champ = bloc.querySelector('.sahiya-renonc__valeur');
    if (!caseACocher || !champ) return;

    bloc.dataset.sahiyaPret = '1';
    formulaire.classList.add('sahiya-renonc-form');

    function refus() {
      signaler(bloc);
    }

    function equiper() {
      poserEcran(boutons.querySelector('.shopify-payment-button'), refus);
    }

    function synchroniser() {
      if (caseACocher.checked) {
        champ.value = horodatage();
        champ.disabled = false;
        formulaire.classList.remove('sahiya-renonc-form--verrou');
      } else {
        champ.value = '';
        champ.disabled = true;
        formulaire.classList.add('sahiya-renonc-form--verrou');
      }
    }

    caseACocher.addEventListener('change', synchroniser);

    boutons.addEventListener('click', function (evenement) {
      if (!formulaire.classList.contains('sahiya-renonc-form--verrou')) return;
      var cible = evenement.target.closest && evenement.target.closest('.product-form__submit');
      if (!cible) return;
      evenement.preventDefault();
      evenement.stopImmediatePropagation();
      refus();
    }, true);

    /* Le bloc de paiement accelere est monte en asynchrone, et le quick view le
       remonte apres injection : on re-equipe a chaque mutation du conteneur. */
    new MutationObserver(equiper).observe(boutons, { childList: true, subtree: true });

    equiper();
    synchroniser();
  }

  /* Garde-fou : capture au niveau du document, donc avant le gestionnaire de
     <product-form> pose sur le formulaire lui-meme. */
  document.addEventListener('submit', function (evenement) {
    var formulaire = evenement.target;
    if (!formulaire || !formulaire.classList) return;
    if (!formulaire.classList.contains('sahiya-renonc-form--verrou')) return;
    evenement.preventDefault();
    evenement.stopImmediatePropagation();
    signaler(formulaire.querySelector('.sahiya-renonc'));
  }, true);

  /* ------------------------------------------------------------------ */
  /* Panier et tiroir : filet secondaire                                */
  /* ------------------------------------------------------------------ */

  function enregistrerAttribut() {
    var corps = { attributes: {} };
    corps.attributes[PROPRIETE] = horodatage();
    return window.fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(corps)
    })['catch'](function () {});
  }

  function initPanier(bloc) {
    if (bloc.dataset.sahiyaPret === '1') return;

    var portee = bloc.closest('form') || document.body;
    var caseACocher = bloc.querySelector('.sahiya-renonc__case');
    var message = bloc.querySelector('.sahiya-renonc__message');
    if (!caseACocher) return;

    bloc.dataset.sahiyaPret = '1';
    portee.classList.add('sahiya-renonc-panier');
    portee.classList.add('sahiya-renonc-panier--verrou');

    function refus() {
      if (message) message.hidden = false;
      signaler(bloc);
    }

    poserEcran(portee.querySelector('.cart__dynamic-checkout-buttons'), refus);

    caseACocher.addEventListener('change', function () {
      if (caseACocher.checked) {
        if (message) message.hidden = true;
        portee.classList.remove('sahiya-renonc-panier--verrou');
        enregistrerAttribut();
      } else {
        portee.classList.add('sahiya-renonc-panier--verrou');
      }
    });

    portee.addEventListener('click', function (evenement) {
      if (!portee.classList.contains('sahiya-renonc-panier--verrou')) return;
      var cible = evenement.target.closest && evenement.target.closest('[name="checkout"]');
      if (!cible) return;
      evenement.preventDefault();
      evenement.stopImmediatePropagation();
      refus();
    }, true);
  }

  /* ------------------------------------------------------------------ */

  function balayer(racine) {
    var noeud = racine && racine.querySelectorAll ? racine : document;
    Array.prototype.forEach.call(noeud.querySelectorAll('[data-sahiya-renonc]'), initFiche);
    Array.prototype.forEach.call(noeud.querySelectorAll('[data-sahiya-renonc-panier]'), initPanier);
  }

  /* Le tiroir et la fiche sont re-rendus par l'API de sections : on observe. */
  new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      for (var j = 0; j < mutations[i].addedNodes.length; j++) {
        var noeud = mutations[i].addedNodes[j];
        if (noeud.nodeType !== 1) continue;
        if (noeud.matches('[data-sahiya-renonc]')) initFiche(noeud);
        else if (noeud.matches('[data-sahiya-renonc-panier]')) initPanier(noeud);
        else balayer(noeud);
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      balayer(document);
    });
  } else {
    balayer(document);
  }
})();
